import React, { useMemo } from 'react'
import { getCurrentPaymentSlug, PaymentTypes, PaymentTypesType, usePaymentsList } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { ChoosePayment } from '../ChoosePayment'
import { CryptoPayment } from '../CryptoPayment'
import { CurrentPayment } from '../CurrentPayment'

import './NowPayments.scss'

interface IPaymentDetails {
  changeSystem: (system: string) => void
  selected: string
  type: PaymentTypesType
}

const b = block('now-payments')

export const NowPayments: React.FC<IPaymentDetails> = ({ changeSystem, selected, type }) => {
  const { additionSlug } = useMemo(() => getCurrentPaymentSlug(selected), [selected])

  const {
    formatted: { cryptoList },
    communications: { cryptoCommunications: { isLoading } }
  } = usePaymentsList({ type })

  if (type === PaymentTypes.PAYOUT && additionSlug) {
    return <CurrentPayment selectedSystem={selected} changeSystem={changeSystem} paymentType={type} />
  }
  return (
    <div className={b()}>
      {additionSlug ? (
        <CryptoPayment
          selectedCrypto={additionSlug}
        />
      ) : (
        <ChoosePayment
          cryptoList={cryptoList}
          changeSystem={changeSystem}
          isLoading={isLoading}
        />
      )}
    </div>
  )
}
